module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_h('div', {
    staticClass: "page cv"
  }, [_h('h1', {
    staticClass: "cv-title"
  }, ["Adam Drobotij"]), " ", _h('h2', {
    staticClass: "cv-email"
  }, [_h('a', {
    attrs: {
      "href": "mailto:hireme@robot-d.com"
    }
  }, ["hireme@robot-d.com"])]), " ", _h('a', {
    staticClass: "cv-pdf",
    attrs: {
      "href": "/static/drobotij_resume_2017.pdf"
    }
  }, ["pdf"]), " ", _h('hr'), " ", _h('ul', {
    staticClass: "cv-list job-list"
  }, [_vm._l((_vm.jobs), function(job) {
    return _h('li', {
      staticClass: "cv-li job"
    }, [_h('div', {
      staticClass: "col__left"
    }, [_h('h2', {
      staticClass: "job__title"
    }, [_vm._s(job.title)]), " ", _h('div', {
      staticClass: "job__dates"
    }, [_vm._s(job.dates)])]), " ", _h('div', {
      staticClass: "col__right"
    }, [(job.link) ? _h('div', [_h('h3', {
      staticClass: "job__company"
    }, [_h('a', {
      attrs: {
        "href": job.link
      }
    }, [_vm._s(job.company)]), (job.city) ? _h('span', [" – ", _h('span', {
      staticClass: "job__city"
    }, [_vm._s(job.city)])]) : _vm._e()])]) : _h('div', [_h('h3', {
      staticClass: "job__company"
    }, [_vm._s(job.company)])]), " ", " ", _h('p', {
      staticClass: "job__description",
      domProps: {
        "innerHTML": _vm._s(job.description)
      }
    }, [_vm._s(job.description)])])])
  })]), " ", _h('hr'), " ", _h('ul', {
    staticClass: "cv-list education-list"
  }, [_h('li', {
    staticClass: "cv-li"
  }, [_h('h2', {
    staticClass: "col__left cv__subhead"
  }, ["Education"]), " ", _h('div', {
    staticClass: "col__right"
  }, [_h('h3', {
    staticClass: "education__title"
  }, ["Carnegie Mellon University – ", _h('span', {}, ["Pittsburgh, PA"])]), " ", _h('p', {
    staticClass: "education__description"
  }, [_h('span', {
    staticClass: "smallcaps"
  }, ["BFA"]), " in Multimedia Art, with a secondary focus on Computer Science."])])])]), " ", _h('hr'), " ", _h('ul', {
    staticClass: "cv-list skills-list"
  }, [_h('li', {
    staticClass: "cv-li"
  }, [_h('div', {
    staticClass: "col__left"
  }, [_h('h2', {
    staticClass: "cv__subhead"
  }, ["Strengths"])]), " ", _h('div', {
    staticClass: "col__right"
  }, [_h('p', [_h('span', {
    staticClass: "smallcaps"
  }, ["HTML"]), ", ", _h('span', {
    staticClass: "smallcaps"
  }, ["CSS/SASS/LESS"]), ", JavaScript, ReactJS, AngularJS, ", _h('span', {
    staticClass: "smallcaps"
  }, ["PHP"]), ", MySQL, Swift iOS, Unity3D, C#, Javascript-based Animation, Drupal, WordPress, ExpressionEngine, jQuery, Bootstrap, SiteCore, ", _h('span', {
    staticClass: "smallcaps"
  }, ["SVN"]), " & Git,\n\t\t\t\t\tActionScript3, Flash Animation, Adobe Suite"])])]), " ", _h('li', {
    staticClass: "cv-li"
  }, [_h('div', {
    staticClass: "col__left"
  }, [_h('h2', {
    staticClass: "cv__subhead"
  }, ["Weaknesses"])]), " ", _h('div', {
    staticClass: "col__right"
  }, [_h('p', ["Homemade Pasta, Bourbon-based Cocktails, Overwatch, Experimental Video Games"])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d6ab2c22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CV.vue
// module id = 27
// module chunks = 1